import { SiteFiltersStore } from "../store";
import { sanitiseVueObservable } from "../../../helpers/sanitiseVueObservable";
import { useSnapshot } from "valtio";

export const useStageIds = (store: SiteFiltersStore) => {
  const { stageIds } = useSnapshot(store);

  return sanitiseVueObservable(stageIds) as string[];
};
